import { z } from 'zod';
import { MATERIAL_CLASSES, MATERIAL_TYPES } from './catalog.js';

/**
 * Material Master arama sorgusu (`satin-alma-akisi.jpeg`): metin, Category, Sub Category,
 * Material Type, "Only Stock Items", "Critical Items", sayfa ve sıra. Ofis ve gemi uç noktaları
 * aynı şemayı kullanır; sorgu dizesindeki değerler metindir.
 */
const flag = z.enum(['true', 'false']).transform((value) => value === 'true');

/**
 * Material Master tablosunun sırası (M6f G5-15): sayfalı veride sıra sunucuda verilir, yoksa
 * yalnız görünen sayfa sıralanır. Değerler beyaz listedir; kolon adı sorgudan gelmez. `category`
 * varsayılandır (kategori sırası, ana ve alt kategori, ad, özellik).
 */
export const MATERIAL_SORTS = ['category', 'name', 'unit', 'type'] as const;
export type MaterialSort = (typeof MATERIAL_SORTS)[number];
export const SORT_DIRECTIONS = ['asc', 'desc'] as const;
export type SortDirection = (typeof SORT_DIRECTIONS)[number];

export const materialQuerySchema = z.strictObject({
  q: z.string().max(200).optional(),
  mainCategory: z.string().max(200).optional(),
  categoryId: z.uuid().optional(),
  materialType: z.enum(MATERIAL_TYPES).optional(),
  /** Sınıf süzgeci (ADR 0122 §3): kumanya ya da stores & spares. */
  materialClass: z.enum(MATERIAL_CLASSES).optional(),
  stockOnly: flag.optional(),
  critical: flag.optional(),
  page: z.coerce.number().int().min(1).max(100_000).optional(),
  pageSize: z.coerce.number().int().min(1).max(100).optional(),
  sort: z.enum(MATERIAL_SORTS).optional(),
  direction: z.enum(SORT_DIRECTIONS).optional(),
});
export type MaterialQueryInput = z.output<typeof materialQuerySchema>;

/** Geminin stoğu sorgusu (ADR 0122 §3): sınıf verilirse yalnız o havuz. */
export const stockQuerySchema = z.strictObject({
  class: z.enum(MATERIAL_CLASSES).optional(),
});

/** Stok hareketleri sorgusu: kalem, sınıf (ADR 0122 §3) ve en çok kaç hareket (varsayılan 50). */
export const stockMovementQuerySchema = z.strictObject({
  item: z.uuid().optional(),
  class: z.enum(MATERIAL_CLASSES).optional(),
  limit: z.coerce.number().int().min(1).max(500).optional(),
});

/** Gemide stok hareketi girişi: mal kabulü (`receipt`) yalnız GRN'den gelir (M12c). */
export const stockMovementInputSchema = z.strictObject({
  stockItemId: z.uuid(),
  kind: z.enum(['in', 'out', 'adjust']),
  quantity: z.number(),
  reason: z.string().max(500).nullish(),
  /** Hareketin gemi yerel günü; verilmezse bugün. */
  localDate: z.iso.date().optional(),
});
